import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../store/auth';
import Navbar from '../components/Navbar';

const AuthLayout = () => {
  const { user, isLoading, checkSession } = useAuthStore();
  const [isChecking, setIsChecking] = useState(true);

  // Periksa sesi dan token ketika komponen dimuat
  useEffect(() => {
    const verifySession = async () => {
      await checkSession();
      setIsChecking(false);
    };

    verifySession();
  }, [checkSession]);

  // Tampilkan loading jika masih memeriksa sesi atau loading dari auth store
  if (isLoading || isChecking) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900" />
      </div>
    );
  }

  // Arahkan ke login jika tidak ada user
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <main className="container mx-auto px-4 py-8">
        <Outlet />
      </main>
    </div>
  );
};

export default AuthLayout;